import React from 'react';
import { motion } from 'framer-motion';

const Loader = () => {
  return (
    <motion.div
      className="fixed inset-0 z-[100] bg-slate-50 flex flex-col items-center justify-center overflow-hidden"
      exit={{ y: "-100%" }}
      transition={{ duration: 1, ease: [0.85, 0, 0.15, 1] }}
    >
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #000 1px, transparent 0)', backgroundSize: '40px 40px' }} />
      </div>

      <div className="relative z-10 flex flex-col items-center">
        <motion.div
           initial={{ opacity: 0, scale: 0.8 }}
           animate={{ opacity: 1, scale: 1 }}
           className="mb-8 px-4"
        >
          <h1 className="text-3xl sm:text-5xl font-black tracking-[0.2em] sm:tracking-[0.4em] text-brand-black italic">
            PKROUTE<span className="text-brand-orange">X</span>
          </h1>
        </motion.div>

        <div className="w-48 sm:w-64 h-[2px] bg-black/5 relative overflow-hidden rounded-full">
          <motion.div
            className="absolute inset-0 bg-brand-orange"
            initial={{ left: "-100%" }}
            animate={{ left: "100%" }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>

        <motion.p
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="mt-6 text-[10px] font-black tracking-[0.5em] text-brand-orange uppercase"
        >
          Initiating Logistics Hub...
        </motion.p>
      </div>

      <div className="absolute bottom-10 text-[8px] font-black text-brand-black/20 tracking-[0.2em] uppercase">
        System Version 2.0.4 // Premium Industrial Protocol
      </div>
    </motion.div>
  );
};

export default Loader;
